"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrefixContext = void 0;
exports.usePrefix = usePrefix;

var _carbonComponents = require("carbon-components");

var _react = _interopRequireDefault(require("react"));

/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PrefixContext = /*#__PURE__*/_react.default.createContext(_carbonComponents.settings.prefix);

exports.PrefixContext = PrefixContext;

function usePrefix() {
  return _react.default.useContext(PrefixContext);
}